export const Toaster = () => null;
export const toast = {
  success: (msg) => alert("✔ " + msg),
  error: (msg) => alert("✖ " + msg),
};
